/**
 * Smoothly scroll the window to the top over a fixed duration with an
 * ease-in-out curve. Native `scrollTo({behavior:'smooth'})` doesn't let us
 * control the duration, so we animate with requestAnimationFrame.
 *
 * @param {number} duration  animation length in ms (default 1000)
 */
export function smoothScrollToTop(duration = 1000) {
  if (typeof window === 'undefined') return;
  const start = window.pageYOffset || document.documentElement.scrollTop || 0;
  if (start <= 0) return;

  // Respect users who prefer reduced motion — jump instantly.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, 0);
    return;
  }

  const startTime = performance.now();
  // ease-in-out quad
  const ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

  const step = (now) => {
    const t = Math.min((now - startTime) / duration, 1);
    window.scrollTo(0, Math.round(start * (1 - ease(t))));
    if (t < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}
